import React from 'react';
import { FormLabel } from '@mui/material';

const styles = {
  maintenanceLabelPadding: {
    marginTop: '11px',
    marginBottom: '6px'
  },
  maintenanceLabel: {
    fontSize: '12px',
  },
  maintenanceInfo: {
    color: 'black',
  },
  paddingMaintenancesFromEachOther: {
    marginBottom: '27px',
  }
};

function FormLabelWithContent(props) {
  const {label, value, maintenance} = props;

  return (
    <>
    <div style={styles.maintenanceLabelPadding}>
      <FormLabel style={styles.maintenanceLabel}>{label}</FormLabel>
    </div>

    <div style={maintenance && styles.paddingMaintenancesFromEachOther}>
      <FormLabel style={styles.maintenanceInfo}>{value ? value : '-'}</FormLabel>
    </div>
    </>
  )
}

export default FormLabelWithContent;
